import React from 'react'
import Header from '../../headerone/Main'
// import Breadcrumb from '../../Bredcom/Main'
import { Link } from 'react-router-dom';

function Main() {
    return (
        <>
            <Header />
            {/* <Breadcrumb title='test' subtitle="testing" /> */}
            <section className="team-area fix p-relative pt-120 pb-80">
                <div className="container">
                    <div className="lower-content">
                        <div className="row">
                            <div className="col-lg-5 col-md-12 col-sm-12">
                                <div className="team-img-box">
                                    <Link to="#">
                                        <img src="https://files.iittp.ac.in/images/demo/iit/anki.jpg" alt="img" />
                                    </Link>
                                </div>
                            </div>
                            <div className="text-column col-lg-7 col-md-12 col-sm-12">
                                <div className="s-about-content pl-30 wow fadeInRight" data-animation="fadeInRight" data-delay=".2s" >
                                    <h2>Prof. Anki Reddy Katha </h2>
                                    <p>Professor</p>
                                    <div className="per-info">
                                        <div className="info-text">
                                            <strong>Department</strong>
                                            <p><Link to="https://chemical.iittp.ac.in/dr-anki-reddy-katha">Chemical Home</Link></p>
                                        </div>
                                        <div className="info-text">
                                            <strong>Personal Webpage</strong>
                                            <p><i className="fal fa-globe" /><Link to="https://scholar.google.com/citations?hl=en&user=4CKTSowAAAAJ">Link</Link></p>
                                        </div>
                                        <div className="info-text">
                                            <p>
                                                <i className="fal fa-phone" />  
                                            </p>
                                            <p>
                                                <i className="fal fa-envelope" />anki.reddy@iittp.ac.in
                                            </p>
                                        </div>
                                    </div>
                                    <div className='text-dark'>

                                        <h3 className='c-headline'>Areas of Interest </h3>                               
                                        <ul className='ms-3' >
                                              <li><i className="fal fa-arrow-alt-circle-right me-3 c-link" />Energy and Environmental Sciences</li>
                                              <li><i className="fal fa-arrow-alt-circle-right me-3 c-link" />Granular Physics</li>
                                              <li><i className="fal fa-arrow-alt-circle-right me-3 c-link" />Computational Biophysics</li>
                                              <li><i className="fal fa-arrow-alt-circle-right me-3 c-link" />Fluid Dynamics</li>
                                              <li><i className="fal fa-arrow-alt-circle-right me-3 c-link" />Suspensions</li>
                                              <li><i className="fal fa-arrow-alt-circle-right me-3 c-link" />Animal Locomotion and Terramechanics</li>
                                        </ul>  

                                        <h3 className='c-headline'>Education</h3>
                                        <ul className='ms-3' >
                                            <li><i className="fal fa-arrow-alt-circle-right  me-3 c-link" />Ph.D., Indian Institute of Science, Bangalore, India </li>
                                        </ul>

                                        <h3 className='c-headline'>Latest Publications</h3>
                                            <ul className='ms-3' >
                                              <li><i className="fal fa-arrow-alt-circle-right me-3 c-link" />A. Vamsikrishna, Sonu Kumar and K. Anki Reddy, "Granular particle-shape heterogeneous mixtures discharging through a silo ", Journal of Fluid Mechanics [2021].</li>
                                              <li><i className="fal fa-arrow-alt-circle-right me-3 c-link" />Shivam Tiwari, Abhijit Gogoi and K. Anki Reddy, "Effect of Ionic Environment on Membrane Fouling:A Molecular Dynamics Study", Physical Chemistry Chemical Physics [2021].</li>
                                              <li><i className="fal fa-arrow-alt-circle-right me-3 c-link" />Pulak Sarkar, Solagna Modak, Santanu Ray, Vasista Adupa, K. Anki Reddy and Santanu Karan, "Fast Water Transport Through Sub-5 nm Polyamide Nanofilms: The New Upper-Bound of the Permeance-Selectivity Trade-Off in Nanofiltration", Journal of Materials Chemistry A [2021].</li>
                                              <li><i className="fal fa-arrow-alt-circle-right me-3 c-link" />A. Vamsi Krishna, K. Anki Reddy, Iker Zuriguel and Hiroaki Katsuragi , " Clogging phenomena in a system of asymmetric dumbbells", Journal of Statistical Mechanics [2021].</li>
                                              <li><i className="fal fa-arrow-alt-circle-right me-3 c-link" />Adupa Vasista, Bhubaneswar Mandal and K. Anki Reddy, "Pro-drug peptide and its metabolites disrupt amyloid fibrils by destabilizing salt bridge interaction and planar beta-sheet topology", bioRxiv.</li>
                                            </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default Main;